import axios from 'axios';
import {all, call, fork, put, takeEvery, select} from "redux-saga/effects";

import {
    REQ_USER_DATA,
    GET_USER_DATA,
    REQ_ADD_USER_DATA,
    GET_ADD_USER_DATA,
    REQ_EDIT_USER_DATA,
    REQ_DELETE_USER_DATA,
    REQ_USER_COMPANY,
    GET_USER_COMPANY,
    REQ_DATA_COMPANY,
    GET_DATA_COMPANY,
    SUCCESS_MESSAGE_USER,
    ERROR_MESSAGE_USER,
    BASE_URL_APIv4,
    BASE_URL_API2,
} from 'constants/ActionTypes';


const key = localStorage.getItem('apiKey')

const getUserData = async () => {
    
    return await axios.get(`${BASE_URL_APIv4}/user/cmd/simple-select?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7&client=datatables&params={%22company%22:%22255%22}`)
                .then((res) => res)
                .catch((error) => error.response)
}

const getUserCompany = async () => {
    
    return await axios.get(`${BASE_URL_API2}/oslog/api/user/cmd/company-access?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`)
                .then((res) => res)
                .catch((error) => error.response)
}

const getDataCompany = async () => {
    
    return await axios.get(`${BASE_URL_API2}/oslog/api/user/cmd/company-access?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`)
                .then((res) => res)
                .catch((error) => error.response)
}

const getAddUser = async (data) => {
    const obj = JSON.stringify(data)
    // console.log(obj)
    return await axios.post(`${BASE_URL_APIv4}/user?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`, obj)
                .then((res) => res)
                .catch((error) => error.response)
}

const getEditUser = async (data) => {
    const obj = JSON.stringify(data.result);
    return await axios.put(`${BASE_URL_APIv4}/user/id/${data.id}?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`, obj)
                .then((res) => res)
                .catch((error) => error.response)
}

const getDeleteUser = async (data) => {
    return await axios.delete(`${BASE_URL_APIv4}/user/id/${data}?apiKey=28de3a17-491d-47d1-a7e8-4ea7d8b0b9b7`)
                .then((res) => res)
                .catch((error) => error.response)
}




export function* setUserData(){
    try {
        const result = yield call(getUserData)
        // console.log(result)
        if(result.status == 200){
            const res = result.data.aaData;

            yield put({type: GET_USER_DATA, payload: res})
        } else {
            const err = 'Opps! looks like something wrong'  
            // console.log(err)
        }
    } catch (error) {
        // console.log(error)
    }
}

export function* setUserCompany(){
    try {
        const result = yield call(getUserCompany)
        
        if(result.status == 200){
            const hasil = result.data;
            const arr = hasil

            yield put({type: GET_USER_COMPANY, payload: arr})
        } else {
            const alert = 'Opps! looks like something wrong'
            // console.log(alert)
        }
    } catch (error) {
        // console.log(error)
    }
}

export function* setDataCompany(){
    try {
        const result = yield call(getDataCompany)
        
        if(result.status == 200){
            const hasil = result.data;

            yield put({type: GET_DATA_COMPANY, payload: hasil})
        } else {
            const err = 'Opps! looks like something wrong'
            // console.log(err)
        }
    } catch (error) {
        // console.log(error)
    }
}

export function* setAddUser(data){
    
    try {
        // console.log('add new user from saga')
        const result = yield call(getAddUser, data.action)
        // console.log(result)
        if(result.status == 200){
            const success = 'Data Successfuly Created'
            yield put({type: SUCCESS_MESSAGE_USER, payload: success})
        }
    } catch (error) {
        const errorMsg = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_USER, payload: errorMsg})
    }
}

export function* setEditUser(data){
   
    try {
        // console.log('add new user from saga')
        // console.log(data.action)
        const result = yield call(getEditUser, data.action)
        // console.log(result)
        
        if(result.status == 200){
            const success = 'Data Successfuly Updated'
            yield put({type: SUCCESS_MESSAGE_USER, payload: success})
        }
    } catch (error) {
        const errorMsg = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_USER, payload: errorMsg})
    }
}

export function* setDeleteUser(data){
   
    try {
        // console.log('add new user from saga')
        // console.log(data.action)
        const result = yield call(getDeleteUser, data.action)
        // console.log(result)
        if(result.status == 200){
            const success = 'Data Successfuly Deleted'
            yield put({type: SUCCESS_MESSAGE_USER, payload: success})
        }
    } catch (error) {
        const errorMsg = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_USER, payload: errorMsg})
    }
}


export function* reqUserData(){
    yield takeEvery(REQ_USER_DATA, setUserData)
}

export function* reqUserCompany(){
    yield takeEvery(REQ_USER_COMPANY, setUserCompany)
}

export function* reqDataCompany(){
    yield takeEvery(REQ_DATA_COMPANY, setDataCompany)
}

export function* reqAddUser(){
    yield takeEvery(REQ_ADD_USER_DATA, setAddUser)
}

export function* reqEditUser(){
    yield takeEvery(REQ_EDIT_USER_DATA, setEditUser)
}

export function* reqDeleteUser(){
    yield takeEvery(REQ_DELETE_USER_DATA, setDeleteUser)
}

export default function* rootSaga() {
    yield all([
        fork(reqUserData),
        fork(reqUserCompany),
        fork(reqDataCompany),
        fork(reqAddUser),
        fork(reqEditUser),
        fork(reqDeleteUser),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/User.js